import fly from "./fly";

// 用户详细接口
export const userInfoApi = (userId: string) => fly.post('/sige/v2/user/profile', {userId})

// 支付方式列表 businessType是业务类型：10 是物业缴费、20 商城缴缴  payChannel:是app发起的传：APP 公众号:WXJS
export const payWayListApi = (params: any) => fly.post('/sige/v2/payment/payMethodList', params)